export function useCanCreateChannels() {
  const { user } = storeToRefs(useUserStore());

  return computed(() => {
    return Boolean(user.value?.can_create_channels);
  });
}
